import { useQuery, UseQueryOptions } from 'react-query-v5';
import api from '../api';
import { ChildOrganizationListDto } from '../api-client';
import { QueryKey } from '../enums';

type ChildOrgQueryPayload = Parameters<
  typeof api.organization.childOrganizationControllerGetChildrenOrganizations
>[1];

export const useGetChildOrganizations = (
  organizationId: string,
  payload: ChildOrgQueryPayload,
  options?: UseQueryOptions<ChildOrganizationListDto>
) =>
  useQuery({
    enabled: !!organizationId,
    queryKey: [QueryKey.Resource.ChildOrganizations, organizationId, payload],
    queryFn: () =>
      api.organization.childOrganizationControllerGetChildrenOrganizations(
        organizationId,
        payload
      ),
    ...options,
  });
